<template>
  <div class="container">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&family=Lobster&family=Open+Sans:wght@400;700&family=Pacifico&family=Playfair+Display:wght@400;700&family=Poppins:wght@400;700&family=Raleway:wght@400;700&family=Roboto:wght@400;700&family=Rock+Salt&display=swap" rel="stylesheet">
    <div class="row" v-if="userRole === 'program_officer'">
      <div class="col-4">
        <div class="input-group">
          <label for="uploadImage">Upload Certificate Image:</label>
          <input
            type="file"
            id="uploadImage"
            accept="image/*"
            @change="uploadImage"
          />

          <div>
            <i class="material-icons" style="font-size: 20px; color: red;"
              >error</i
            >
            <span>
              Please make sure to upload the high resolution blank certificate
              that has been provided in the soft form by the comms section.
            </span>
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="input-group">
          <label for="textInput">Enter Name:</label>
          <input type="text" v-model="textInput" placeholder="Enter Name" />
        </div>
      </div>
      <div class="col-2">
        <div class="input-group">
          <label for="colorInput">Text Color:</label>
          <input type="color" class="color-select" v-model="colorInput" />
        </div>
      </div>
      <div class="col-2">
        <div class="input-group">
          <label for="fontSizeInput">Font Size:</label>
          <input type="number" v-model="fontSizeInput" min="10" max="100" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="input-group" v-if="userRole === 'program_officer'">
          <label for="fontSelect">Font Style:</label>
          <select v-model="fontSelect">
            <option
              v-for="font in fonts"
              :key="font"
              :value="font"
              :style="{ fontFamily: font }"
              class="font-option"
            >
              {{ font }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-8 d-flex">
        <button
          class="btn add-btn mr-3 ml-2"
          v-if="userRole === 'program_officer'"
          @click="addText"
        >
          Add Text
        </button>
        <button
          class="btn download-btn mr-3"
          @click="savePDF"
          v-if="userRole === 'program_officer' && !update"
          :disabled="saveBtn"
        >
          Save
        </button>
        <button
          class="btn download-btn mr-3"
          @click="updatePDF"
          v-if="userRole === 'program_officer' && update"
          :disabled="saveBtn"
        >
          Update
        </button>

        <button
          class="btn download-btn ml-auto"
          @click="downloadPDF"
          :disabled="saveBtn"
        >
          Download PDF
        </button>
      </div>
    </div>

    <canvas ref="certificateCanvas"></canvas>
  </div>
</template>

<script>
import {
    jsPDF
} from "jspdf";
import axios from "axios";

export default {
    data() {
        return {
            textInput: "",
            colorInput: "#000000",
            fontSizeInput: 60,
            fontSelect: "Arial",
            fonts: [
                "Arial",
                "Verdana",
                "Courier New",
                "Georgia",
                "Times New Roman",
                "Trebuchet MS",
                "Impact",
                "Tahoma",
                "Lucida Console",
                "Comic Sans MS",
                "Arial Black",
                "sans-serif",
                "serif",
                "Lobster",
                "Dancing Script",
                "Pacifico",
                "Rock Salt",
                "Roboto",
                "Open Sans",
                "Poppins",
                "Raleway",
                "Playfair Display"
            ],
            canvas: null,
            ctx: null,
            img: new Image(),
            textElements: {},
            isDragging: true,
            selectedText: null,
            offsetX: 0,
            offsetY: 0,
            certificate: '',
            userRole: localStorage.getItem("isPermission"),
            trainingId: '',
            saveBtn: true,
            imageUrl: '',
            trainingCode: '',
            update: false,
        };
    },
    mounted() {
        this.getTrainingId()

        this.canvas = this.$refs.certificateCanvas;
        this.ctx = this.canvas.getContext("2d");

        this.canvas.addEventListener("mousedown", this.handleMouseDown);
        this.canvas.addEventListener("mousemove", this.handleMouseMove);
        this.canvas.addEventListener("mouseup", this.handleMouseUp);

    },
    beforeDestroy() {
        this.canvas.removeEventListener("mousedown", this.handleMouseDown);
        this.canvas.removeEventListener("mousemove", this.handleMouseMove);
        this.canvas.removeEventListener("mouseup", this.handleMouseUp);
    },

    methods: {

        getTrainingId() {
            axios.defaults.headers['Authorization'] = localStorage.getItem('token')
            this.trainingCode = this.$route.query.trainingId;

            this.openLoading();
            axios.get(localStorage.getItem("BASE_PATH") +
                    "/programOfficer/trainingsingle/get/" +
                    this.trainingCode

                )
                .then(response => {
                    this.closeLoading();
                    this.trainingId = response.data.training.id;
                    this.getTraining(response.data.training.id);
                });

        },
        loadImage() {
            this.img = new Image();
            this.img.crossOrigin = "Anonymous"; // Prevent CORS issues if needed

            this.img.onload = () => {
                this.adjustCanvasSize();
                this.drawCanvas();
                this.renderText();

            };
            this.img.src = this.imageUrl;
        },

        drawCanvas() {
            if (!this.canvas || !this.ctx || !this.img) return;

            // Clear canvas
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

            // Draw the certificate image
            this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
        },
        uploadImage(event) {
            const file = event.target.files[0];
            if (file) {
                this.certificate = file
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.img.onload = this.adjustCanvasSize;
                    this.img.src = e.target.result;
                };
                reader.readAsDataURL(file);

            }
        },
        adjustCanvasSize() {
            const maxWidth = window.innerWidth * 0.9;
            const maxHeight = window.innerHeight * 0.8;
            const aspectRatio = this.img.naturalWidth / this.img.naturalHeight;

            if (aspectRatio > 1) {
                this.canvas.width = Math.min(maxWidth, this.img.naturalWidth);
                this.canvas.height = this.canvas.width / aspectRatio;
            } else {
                this.canvas.height = Math.min(maxHeight, this.img.naturalHeight);
                this.canvas.width = this.canvas.height * aspectRatio;
            }

            this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
            setTimeout(() => {
                this.renderText();
                this.closeLoading();
            }, 2000);

        },
        addText() {
            if (!this.textInput) return alert("Please enter some text.");
            this.saveBtn = false,
                this.textElements = {
                    text: this.textInput,
                    x: 864,
                    y: 311,
                    fontSize: this.fontSizeInput,
                    color: this.colorInput,
                    fontFamily: this.fontSelect,
                };
            this.renderText();
        },
        renderText() {
            this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
            const el = this.textElements;
            
            // Wait for font to load before rendering
            document.fonts.ready.then(() => {
                this.ctx.font = `${el.fontSize}px "${el.fontFamily}"`;
                this.ctx.fillStyle = el.color;
                this.ctx.textAlign = "center";
                this.ctx.fillText(el.text, el.x, el.y);

                // Draw "This is TMIS generated certificate" in rotated position
                this.ctx.save();
                const midLeftX = 50;
                const midLeftY = this.canvas.height / 2;
                this.ctx.translate(midLeftX, midLeftY);
                this.ctx.rotate(-Math.PI / 2);
                this.ctx.font = "14px Arial";
                this.ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
                this.ctx.textAlign = "center";
                this.ctx.fillText("This is TMIS generated certificate", 0, 30);
                this.ctx.restore();
            });
        },
        handleMouseDown(e) {
            const rect = this.canvas.getBoundingClientRect();
            const mouseX = e.clientX - rect.left;
            const mouseY = e.clientY - rect.top;

            // for (let i = this.textElements.length - 1; i >= 0; i--) {
            const el = this.textElements;
            const textWidth = this.ctx.measureText(el.text).width;
            const textHeight = el.fontSize;

            if (
                mouseX >= el.x - textWidth / 2 &&
                mouseX <= el.x + textWidth / 2 &&
                mouseY >= el.y - textHeight &&
                mouseY <= el.y
            ) {
                this.selectedText = el;
                this.isDragging = true;
                this.offsetX = mouseX - el.x;
                this.offsetY = mouseY - el.y;
                return;
            }
            // }
        },
        handleMouseMove(e) {
            if (!this.isDragging || !this.selectedText) return;
            const rect = this.canvas.getBoundingClientRect();
            this.selectedText.x = e.clientX - rect.left - this.offsetX;
            this.selectedText.y = e.clientY - rect.top - this.offsetY;
            this.renderText();
        },
        handleMouseUp() {
            this.isDragging = false;
        },
        downloadPDF() {
            const pdf = new jsPDF("landscape", "pt", [this.canvas.width, this.canvas.height]);
            const imgData = this.canvas.toDataURL("image/png");
            pdf.addImage(imgData, "PNG", 0, 0, this.canvas.width, this.canvas.height);
            pdf.save("certificate.pdf");
        },
        savePDF() {
            let formData = new FormData();
            formData.append("title", this.textElements.text);
            formData.append("file", this.certificate);
            formData.append("xAxis", this.textElements.x);
            formData.append("yAxis", this.textElements.y);
            formData.append("fontSize", this.textElements.fontSize);
            formData.append("fontFamily", this.textElements.fontFamily);
            formData.append("fontColor", this.textElements.color);
            formData.append("trainingId", this.trainingId);
            this.openLoading();
            axios
                .post(
                    localStorage.getItem("BASE_PATH") +
                    "/admin/upload-certificates",
                    formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: localStorage.getItem("token"),
                        }
                    }
                )
                .then(response => {
                    this.closeLoading();
                    if (response) {
                        this.toastSuccess("Record has been added successfully!");

                    } else if (response.data.error) {
                        throw response.data.error;
                    }
                })
                .catch(error => {
                    this.toastError(error);
                });
        },

        updatePDF() {

            let formData = new FormData();
            formData.append("title", this.textElements.text);
            formData.append("file", this.certificate);
            formData.append("xAxis", this.textElements.x);
            formData.append("yAxis", this.textElements.y);
            formData.append("fontSize", this.textElements.fontSize);
            formData.append("fontFamily", this.textElements.fontFamily);
            formData.append("fontColor", this.textElements.color);
            // formData.append("trainingId", this.trainingId);
            this.openLoading();
            axios
                .put(
                    localStorage.getItem("BASE_PATH") +
                    "/admin/upload-certificates/" + this.trainingId,
                    formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            Authorization: localStorage.getItem("token"),
                        }
                    }
                )
                .then(response => {
                    this.closeLoading();
                    if (response) {
                        this.toastSuccess("Record has been update successfully!");

                    } else if (response.data.error) {
                        throw response.data.error;
                    }
                })
                .catch(error => {
                    this.closeLoading();
                    this.toastError(error);
                });
        },
        getTraining(id) {
            axios
                .get(localStorage.getItem("BASE_PATH") + "/admin/upload-certificates/" + id)
                .then(response => {
                    if (response.data.length > 0) {
                        // this.openLoading();
                        this.update = true;
                        const certificateData = response.data[0]; // Fixing incorrect data reference
                        const currentUser = JSON.parse(localStorage.getItem("currentUser"));

                        // Set text elements for rendering
                        this.textElements = {
                            text: currentUser ? currentUser.name : " ",
                            x: certificateData.xAxis,
                            y: certificateData.yAxis,
                            fontSize: certificateData.fontSize,
                            color: certificateData.fontColor,
                            fontFamily: certificateData.fontFamily
                        };

                        this.imageUrl = localStorage.getItem("BASE_PATH") + "/" + certificateData.uploadfile
                        this.loadImage();
                    }
                })
                .catch(error => {
                    this.closeLoading();
                    this.toastError("Error fetching training data:", error);

                });
        },

        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
    },
    created() {
        window.addEventListener("mouseup", this.handleMouseUp);
    },

}
</script>

<style scoped>
body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f4f4f4;
}

.container {
    width: 100%;
    max-width: 100%;
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.input-group {
    display: flex;
    flex-direction: column;
    margin: 10px;
}

label {
    font-weight: bold;
    margin-bottom: 5px;
}

input,
select,
button {
    padding: 5px;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid #ccc;
}

#colorInput {
    padding: 4px !important;
    width: 96%;
}

.btn {
    background-color: #007BFF;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn:hover {
    background-color: #0888b7 !important;
}

canvas {
    width: 100%;
    border: 1px solid #ccc;
    margin-top: 20px;
}

.add-btn {
    margin-top: 33px;
    height: 36px;
    background-color: #06a6e0 !important;
}

.download-btn {
    margin-top: 33px;
    height: 36px;
    background-color: #06a6e0 !important;
}

.right {
    text-align: right;
}

.color-select {
    width: 50%;
    height: 42px;
}

select {
    font-size: 16px;
    padding: 5px;
    width: 200px;
}

select option {
    font-size: 16px;
    padding: 5px;
}

/* Add specific font-family styles for the select options */
.font-option {
    font-family: inherit;
    padding: 5px;
}

/* Update your existing select styles */
select option[value="Roboto"] { font-family: 'Roboto', sans-serif; }
select option[value="Open Sans"] { font-family: 'Open Sans', sans-serif; }
select option[value="Poppins"] { font-family: 'Poppins', sans-serif; }
select option[value="Raleway"] { font-family: 'Raleway', sans-serif; }
select option[value="Playfair Display"] { font-family: 'Playfair Display', serif; }
select option[value="Dancing Script"] { font-family: 'Dancing Script', cursive; }
select option[value="Pacifico"] { font-family: 'Pacifico', cursive; }
select option[value="Rock Salt"] { font-family: 'Rock Salt', cursive; }
select option[value="Lobster"] { font-family: 'Lobster', cursive; }

/* Font loading styles */
@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&family=Lobster&family=Open+Sans:wght@400;700&family=Pacifico&family=Playfair+Display:wght@400;700&family=Poppins:wght@400;700&family=Raleway:wght@400;700&family=Roboto:wght@400;700&family=Rock+Salt&display=swap');

/* Font classes */
.font-dancing-script { font-family: 'Dancing Script', cursive; }
.font-lobster { font-family: 'Lobster', cursive; }
.font-open-sans { font-family: 'Open Sans', sans-serif; }
.font-pacifico { font-family: 'Pacifico', cursive; }
.font-playfair { font-family: 'Playfair Display', serif; }
.font-poppins { font-family: 'Poppins', sans-serif; }
.font-raleway { font-family: 'Raleway', sans-serif; }
.font-roboto { font-family: 'Roboto', sans-serif; }
.font-rock-salt { font-family: 'Rock Salt', cursive; }
</style>
